interface SiriusLogoProps {
  className?: string;
}

const SiriusLogo = ({ className = "h-6 w-6" }: SiriusLogoProps) => {
  return (
    <svg 
      width="5643" 
      height="5967" 
      viewBox="0 0 5643 5967" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M4158 1188C4343.43 1013.06 4329 558 4329 558C4329 558 4334.75 1016.09 4527 1188C4676.13 1321.35 5013 1350 5013 1350C5013 1350 4689.32 1397.65 4545 1530C4363.08 1696.83 4329 2124 4329 2124C4329 2124 4329.07 1700.31 4158 1530C4002.83 1375.52 3627 1350 3627 1350C3627 1350 4000.3 1336.78 4158 1188Z" 
        fill="currentColor"
      />
      <path 
        d="M3187 2576.96L3195.5 2627.42L3245.95 2635.98L5232.27 2973.28L3262.81 3340.22L3213.75 3349.36L3205.09 3398.52L2826.72 5547.68L2455.95 3398.76L2447.42 3349.32L2398.09 3340.2L412.302 2973.02L2397.05 2635.98L2447.32 2627.45L2455.96 2577.2L2825.27 429.176L3187 2576.96Z" 
        stroke="currentColor" 
        strokeWidth="144"
      />
    </svg>
  );
};

export default SiriusLogo;